/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fireTriggeredAction} from '../api'

export const useMutationFireTriggeredAction = createReactQueryMutationHook('fireTriggeredAction', fireTriggeredAction)
